import { X } from 'lucide-react';
import React, { PropsWithChildren } from 'react';
import { useDialog } from '../../context/Dialog';

export default function ({
  children,
  className = '',
}: PropsWithChildren & { className?: string }) {
  const { closeDialog } = useDialog();
  return (
    <div className={` ${className} flex gap-4 justify-end items-start`}>
      {children && (
        <h5 className={`high-emphasis-text font-bold flex-1`}>
          {children}
          <span></span>
        </h5>
      )}
      <button
        type="button"
        className="medium-emphasis-text p-1"
        onClick={() => closeDialog({ keepParent: true })}
      >
        <X className="size-6" />
      </button>
    </div>
  );
}
